import { Component, ElementRef, HostBinding, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { IconType } from './shared/enums/icon-type.enum';
import { DOCUMENT } from '@angular/common';
import { last } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'a[da-link], button[da-link]',
    templateUrl: './da-link.component.html',
    styleUrls: ['./da-link.component.scss'],
    standalone: false
})
export class DaLinkComponent implements OnInit {
    @Input() link: string;
    @Input() href: string;
    @Input() rel: string;
    @Input() icon: IconType;
    @Input() tabIndex: number;
    @Input() isDisabled: boolean;
    private readonly _isButton: boolean;

    constructor(@Inject(DOCUMENT) private document: any, private el: ElementRef) {
        this._isButton = el.nativeElement.nodeName === 'BUTTON';
    }

    @HostBinding('attr.tabindex')
    public get bindTabIndex() {
        return this.isDisabled ? -1 : this.tabIndex || 0;
    }

    @HostBinding('attr.href')
    public get bindHrefIfAnchor() {
        let link = this.link || this.href;
        link = this._getFormattedlink(link);
        return this._isButton || this.isDisabled ? null : link || null;
    }

    @HostBinding('attr.target')
    public get bindTarget() {
        let link = this.link || this.href;
        if (link) {
            link = link.toLowerCase();
            const linkType = this._getLinkType(link);
            return linkType === 'External' || linkType === 'Download' ? '_blank' : '_self';
        }

        return null;
    }

    @HostBinding('attr.disabled')
    public get bindDisabledState() {
        return this._isButton ? this.isDisabled || null : null;
    }

    @HostBinding('attr.role')
    public get bindRole() {
        return this._isButton ? 'button' : null;
    }

    @HostBinding('attr.rel')
    public get bindRel() {
        return !this._isButton && this.bindTarget === '_blank' ? this.rel || 'noopener' : null;
    }

    ngOnInit() {}
    private _getLinkType(link): string {
        let linkType = 'Internal';
        // If the link starts with "http", it should be handled as external
        if (link) {
            if (link.match(/^http/) !== null) {
                linkType = 'External';
            }
            // Does the URL includes something like .draeger.com? If yes, it should be handled as internal
            if (link.indexOf('.draeger.com') > -1) {
                linkType = 'Internal';
                if (link.indexOf('static.draeger.com') > -1) {
                    linkType = 'External';
                }
            }

            if (link.indexOf('.pdf') > -1 || link.indexOf('.zip') > -1) {
                linkType = 'Download';
            }

            if (link.indexOf('#') === 0) {
                linkType = 'Anchor';
            }
        }
        return linkType;
    }

    private _getFormattedlink(link: string): string {
        let formattedLink = link;
        const _isPhone = link && link.match(/^tel:/g) !== null;
        const _isMailTo = link && link.match(/^mailto:/g) !== null;
        const _isAnchor = link && link.indexOf('#') === 0;
        if (link && !_isPhone && !_isMailTo && !_isAnchor) {
            const linkType = this._getLinkType(link);
            if (linkType === 'Internal') {
                if (link[0] !== '#' && link[0] !== '/' && link.match(/^https?:\/\/.*/g) === null) {
                    formattedLink = '/' + link;
                }
            }
        }
        if (link && _isAnchor) {
            formattedLink = `${window.location.pathname}${link}`;
        }
        return formattedLink;
    }
}
